import { createAction, props } from '@ngrx/store';
import { AuthStep } from '@app/core/authentication/enums/auth-step.enum';
import { IAuthErrorResponse, ILoginResponse, ILoginWithEncryptPassword } from '@app/api/interfaces/auth.interface';
import { IAuthStepData } from '@app/core/authentication/interfaces/auth-step-data';

export const logout = createAction('[Auth] Logout');

export const logoutSuccess = createAction('[Auth] Logout Success');
export const clearStore = createAction('[Auth] Clear Store');

export const initAuth = createAction('[Auth] Init');

export const initAuthSuccess = createAction(
  '[Auth] Init Success',
  props<{
    step: AuthStep;
  }>()
);

export const setAuthStep = createAction(
  '[Auth] Set Auth Step',
  props<{
    step: AuthStep;
    stepData: IAuthStepData;
    withoutRedirect?: boolean;
    clearAllStore?: boolean;
  }>()
);

export const endAuthStepHandler = createAction(
  '[Auth] End Auth Step Handle',
  props<{
    error: IAuthErrorResponse | null;
    success: ILoginResponse | null;
    sharedAuthContext?: ILoginWithEncryptPassword;
  }>()
);

export const setAuthError = createAction(
  '[Auth] Set Auth Error',
  props<{
    error: IAuthErrorResponse;
  }>()
);
